module.exports = __webpack_public_path__ + "static/media/write-text-icon.9227e5fd.svg";